<template>
  <div class="visitor-sitelist">
    <el-row class="row-title"
            :gutter="50">
      <el-col :span="2">&nbsp;</el-col>

      <el-col :span="span">网站</el-col>
      <!-- <el-col :span="span">Title</el-col> -->
      <el-col :span="span">时长</el-col>
    </el-row>
    <el-row class="tr-row"
            :gutter="50"
            v-for="(item,i) in getData"
            :key="Math.random()+''+i">
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="span"
              class="page-path">
        <open-link :value="item.displayPageName"></open-link>
      </el-col>
      <!-- <el-col :span="span">{{item.pageTitle}}</el-col> -->
      <el-col :span="span">{{item.timeOnPageStr}}</el-col>
    </el-row>
  </div>
</template>

<script>
import openLink from '@/components/tools/open-link.vue'

export default {
  props: ['scope', 'tableData'],
  components: {
    openLink
  },
  computed: {
    getData () {
      return this.scope.row.visitRouteList
    }
  },
  data () {
    return {
      span: 7
    }
  },

}
</script>

<style lang="scss">
.visitor-sitelist {
  .row-title {
    margin: 20px 0;
    font-size: 14px;
    font-weight: 500;
  }
  .tr-row {
    margin-bottom: 15px;
    .page-path {
      color: #3da1ff;
      // text-overflow: ellipsis;
      // overflow: hidden;
      & > .link-text {
        white-space: wrap;
        word-wrap: break-word;
        word-break: keep-all;
      }
    }
  }
}
</style>
